import PropTypes from 'prop-types';
import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup';

const propTypes = {
  children: PropTypes.node,
  layout: PropTypes.string
};

const FieldsWrapper = ({ children, layout }) => {
  return layout === 'page' ? <FormGroup>{children}</FormGroup> : children;
};

FieldsWrapper.propTypes = propTypes;

export default FieldsWrapper;
